import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { NgModule } from "@angular/core";
import { SharedModule } from "@app/shared/shared.module";
import { AuditLogListComponent } from "./components/audit-log-list/audit-log-list.component";
import { LogFilterBadgetComponent } from "./components/log-filter-badget/log-filter-badget.component";
import { LogFilterComponent } from "./components/log-filter/log-filter.component";
import { AuditLogStoreModule } from "./store/audit-log-store.module";

@NgModule({
    imports: [AuditLogStoreModule, SharedModule, FormsModule, ReactiveFormsModule],
    declarations: [AuditLogListComponent, LogFilterComponent, LogFilterBadgetComponent],
    providers: [],
    exports: [AuditLogListComponent],
})
export class AuditLogModule {}
